var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreLayout,
    { style: _setup.colorVarStyles },
    [
      _c(_setup.LpuStaffAdmin),
      _vm._v(" "),
      !_setup.isMobile
        ? _c(_setup.CoreBread, { attrs: { items: _setup.breadcrumbs } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "lpu-branding container position-relative",
          class: {
            "lpu-branding--mobile pt-4": _setup.isMobile,
            "lpu-branding--phone-bar":
              _setup.isMobile &&
              _setup.appointmentPhone &&
              !_setup.isSpecialistsOnly,
            "mb-5": !_setup.isMobile,
          },
          attrs: {
            "data-qa": "lpu_page_price",
            itemtype: "https://schema.org/LocalBusiness",
            itemscope: "",
          },
        },
        [
          _c("meta", {
            attrs: {
              itemprop: "name",
              content: _setup.tDynamic(_setup.context.lpu, "name"),
            },
          }),
          _vm._v(" "),
          _setup.localBusinessItemprops.telephone
            ? _c("meta", {
                attrs: {
                  itemprop: "telephone",
                  content: _setup.localBusinessItemprops.telephone,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.localBusinessItemprops.addressLocality ||
          _setup.localBusinessItemprops.streetAddress
            ? _c(
                "span",
                {
                  attrs: {
                    itemprop: "address",
                    itemscope: "",
                    itemtype: "https://schema.org/PostalAddress",
                  },
                },
                [
                  _setup.localBusinessItemprops.addressLocality
                    ? _c("meta", {
                        attrs: {
                          itemprop: "addressLocality",
                          content:
                            _setup.localBusinessItemprops.addressLocality,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.localBusinessItemprops.streetAddress
                    ? _c("meta", {
                        attrs: {
                          itemprop: "streetAddress",
                          content: _setup.localBusinessItemprops.streetAddress,
                        },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.localBusinessItemprops.priceRange
            ? _c("meta", {
                attrs: {
                  itemprop: "priceRange",
                  content: _setup.localBusinessItemprops.priceRange,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.localBusinessItemprops.logo
            ? _c("meta", {
                attrs: {
                  itemprop: "logo",
                  content: _setup.localBusinessItemprops.logo,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.context.request.feature_flags.ff_lpu_branding_page_v2 &&
          _setup.context.is_lpu_branding_preview
            ? _c(_setup.PreviewMenu, {
                staticClass: "order-first",
                attrs: { "lpu-id": _setup.context.lpu.id },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex flex-column ga-6" },
            [
              !_setup.isMobile
                ? _c(_setup.HeroSectionDesktop, {
                    attrs: {
                      lpu: _setup.context.lpu,
                      "lpu-branding": _setup.context.lpu_branding,
                      "lpu-video-card": _setup.context.lpu_video_card,
                      "synonym-prices-count":
                        _setup.context.synonym_prices_count,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _setup.context.request.feature_flags.ff_lpu_branding_page_v2
                ? _c(_setup.SectionMenu, {
                    attrs: {
                      "active-item-id": "prices",
                      lpu: _setup.context.lpu,
                      "synonym-prices-count":
                        _setup.context.synonym_prices_count,
                      "lpu-page-href": _setup.lpuPageHref,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(_setup.PriceLpuBack, { attrs: { lpu: _setup.context.lpu } }),
          _vm._v(" "),
          _c(_setup.PriceSection, { tag: "component" }),
          _vm._v(" "),
          _setup.isMobile && !_setup.isSpecialistsOnly
            ? _c(_setup.PricePhoneBar, {
                attrs: {
                  phone: _setup.appointmentPhone,
                  href: _setup.appointmentPhoneHref,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.isClientMounted ? _c(_setup.InvasiveServiceInfo) : _vm._e(),
          _vm._v(" "),
          _c(_setup.CoreSnackbar),
          _vm._v(" "),
          _c("meta", {
            attrs: {
              itemprop: "url",
              content: _setup.context.lpu.site || _setup.lpuPageHref,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _setup.isMobile
        ? _c(_setup.BreadcrumbsJsonLd, {
            attrs: { json: _setup.breadcrumbsJsonLd },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.BreadcrumbsJsonLd, {
        attrs: { json: _setup.localBusinessJsonLd },
      }),
      _vm._v(" "),
      _c(_setup.LpuPopupMap),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }